var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    { staticClass: "pa-0", attrs: { fluid: "", id: "step21" } },
    [
      _c(
        "v-card",
        [
          _c(
            "v-card-actions",
            { staticClass: "card-bg-2" },
            [
              _c(
                "v-btn",
                {
                  attrs: { color: "info" },
                  on: {
                    click: function ($event) {
                      return _vm.generate()
                    },
                  },
                },
                [
                  _c("v-icon", { staticClass: "mr-1" }, [
                    _vm._v("insert_chart"),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "text-capitalize" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("Button.Generat_Graph_Dashboard")) +
                        "\n        "
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticStyle: { background: "white" } },
            [
              _c(
                "v-alert",
                {
                  staticClass: "ma-0",
                  attrs: {
                    value: !_vm.hasWaterMediaType,
                    type: "warning",
                    outline: "",
                  },
                },
                [
                  _c("div", { staticClass: "primary--text" }, [
                    _vm._v(
                      "\n          Sorry, graphs are only available for water samples.\n        "
                    ),
                  ]),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("v-divider"),
          _vm._v(" "),
          _c(
            "v-layout",
            { staticClass: "card-bg-2" },
            [
              _c(
                "v-flex",
                { staticClass: "divider-right", attrs: { xs12: "", md5: "" } },
                [
                  _c("v-card-title", { staticClass: "headline pb-0" }, [
                    _vm._v("Media Types"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "v-card-text",
                    { staticClass: "py-0" },
                    [
                      _c(
                        "v-radio-group",
                        {
                          attrs: { row: "" },
                          model: {
                            value: _vm.selectedMedia,
                            callback: function ($$v) {
                              _vm.selectedMedia = $$v
                            },
                            expression: "selectedMedia",
                          },
                        },
                        [
                          _vm._l(_vm.analyteMediaTypes, function (m) {
                            return [
                              _c("v-radio", {
                                key: m,
                                attrs: { color: "info", label: m, value: m },
                              }),
                            ]
                          }),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("v-divider"),
                  _vm._v(" "),
                  _c("v-card-title", { staticClass: "headline" }, [
                    _vm._v("Date Range"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "v-card-text",
                    { staticClass: "py-0" },
                    [
                      _c("DateRange", {
                        attrs: {
                          rounded: "",
                          solo: "",
                          minDate: _vm.minDate,
                          maxDate: _vm.maxDate,
                          availableDateRange: {
                            start: _vm.minDate,
                            end: _vm.maxDate,
                          },
                          "min-max-placeholder": _vm.formats.prettyDateFormat,
                          shortcutPrefix: "Show",
                          shortcuts: _vm.shortcuts,
                          "no-arrows": "",
                          data: _vm.availableDates,
                        },
                        model: {
                          value: _vm.dates,
                          callback: function ($$v) {
                            _vm.dates = $$v
                          },
                          expression: "dates",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("v-divider"),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-flex",
                { staticClass: "divider-left", attrs: { xs12: "", md5: "" } },
                [
                  _vm.hasWaterMediaType
                    ? _c("WaterQualityGuideline", {
                        attrs: {
                          selectedMedia: _vm.selectedMedia,
                          selectedGuidelines: _vm.selectedGuidelines,
                          preConfig: _vm.preConfig,
                        },
                        on: { onGuidelineSelect: _vm.onGuidelineSelectHandler },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.hasWaterMediaType
        ? _c("StationWaterQualityDashChart", {
            attrs: { graphRequestData: _vm.graphRequestData },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }